module.exports = __webpack_public_path__ + "img/user-bg.7fb8ee49.png";